import { render, staticRenderFns } from "./personnelInput.vue?vue&type=template&id=afb5c502"
import script from "./personnelInput.vue?vue&type=script&lang=js"
export * from "./personnelInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports